// eslint-disable-next-line import/prefer-default-export
export var EntityTypePrefix;
(function (EntityTypePrefix) {
    EntityTypePrefix["Inspection"] = "Inspection";
    EntityTypePrefix["Visit"] = "Visit";
})(EntityTypePrefix || (EntityTypePrefix = {}));
